import * as React from 'react';

export class Fragment extends React.Component<{}> {
	render(): any {
		return this.props.children;
	}
}
